"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchApi = void 0;
const api_1 = require("../api");
const contentTypeApplicationJson = { 'Content-Type': 'application/json' };
function FetchApi(key, onUnauthorized, onError) {
    const apiHeader = { 'X-api-key': key };
    const processApiResponse = (toJson) => {
        return (response) => __awaiter(this, void 0, void 0, function* () {
            if (response.ok) {
                return toJson ? yield response.json() : response;
            }
            if (response.status === 401) {
                if (onUnauthorized) {
                    onUnauthorized();
                    return null;
                }
            }
            throw new Error(`Api returned status code ${response.status} - ${response.statusText}`);
        });
    };
    const get = (url, nativeProcessing) => {
        return fetch(url, {
            headers: apiHeader
        }).then(processApiResponse(!nativeProcessing));
    };
    const post = (url, data, nativeProcessing, stringify = true) => {
        return fetch(url, {
            method: 'POST',
            headers: Object.assign(Object.assign({}, apiHeader), stringify ? contentTypeApplicationJson : {}),
            body: stringify ? JSON.stringify(data) : data
        }).then(processApiResponse(!nativeProcessing));
    };
    return new api_1.Api(get, post, onError);
}
exports.FetchApi = FetchApi;
